import * as yup from "yup";
import { Countries, INDUSTRIES } from "../../../../utilities/constants";
import { candidateRegion, candidateType, employmentDuration, employmentTypes, shiftType, urgencyLevel } from "../../../../utilities/dropdowns";

export const filterFormSchema = yup.object().shape({
  email: yup.string("The email is not valid."),
});

export const filterFormFields = () => [
  {
    stepNo: 1,
    title: "Personal Information",
    fields: [
      {
        name: "name",
        fieldId: "name",
        label: "Name",
        placeholder: "Petar",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "email",
        fieldId: "email",
        label: "E-mail",
        placeholder: "petar@gmail.com",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "country",
        fieldId: "country",
        label: "Country",
        placeholder: "Macedonia",
        type: "select",
        values: [{ label: "Select a country", value: "", disabled: true }, ...Countries.map((i) => ({ label: i, value: i }))],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "city",
        fieldId: "city",
        label: "City",
        placeholder: "Skopje",
        type: "input-text",
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "industry",
        fieldId: "industry",
        label: "Industry",
        placeholder: "Economics",
        type: "select",
        values: [{ label: "Select an industry", value: "" }, ...INDUSTRIES.asList()],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "isVerified",
        fieldId: "isVerified",
        label: "Account Verified",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "isEmailVerified",
        fieldId: "isEmailVerified",
        label: "Email Verified",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
    ],
  },
  {
    stepNo: 2,
    title: "Other Information",
    fields: [
      {
        name: "candidateTypes",
        fieldId: "candidateTypes",
        label: "Candidate Type",
        placeholder: "Students",
        type: "select",
        values: [{ label: "Select an candidate type", value: "" }, ...candidateType],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "candidateRegion",
        fieldId: "candidateRegion",
        label: "Candidate Region",
        placeholder: "Only EU",
        type: "select",
        values: [{ label: "Select an candidate region", value: "" }, ...candidateRegion],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "employmentTypes",
        fieldId: "employmentTypes",
        label: "Employment Type",
        placeholder: "Full-time",
        type: "select",
        values: [{ label: "Select an employment type", value: "" }, ...employmentTypes],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "urgencyLevel",
        fieldId: "urgencyLevel",
        label: "Urgency level",
        placeholder: "ASAP",
        type: "select",
        values: [{ label: "Select an urgency level", value: "" }, ...urgencyLevel],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "employmentDuration",
        fieldId: "employmentDuration",
        label: "Employment Duration",
        placeholder: "< 3 months",
        type: "select",
        values: [{ label: "Select an employment duration", value: "" }, ...employmentDuration],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "shiftType",
        fieldId: "shiftType",
        label: "Shift Type",
        placeholder: "Fixed shift",
        type: "select",
        values: [{ label: "Select an shift type", value: "" }, ...shiftType],
        style: {
          padding: "0 10px",
          size: "small",
        },
        isRequired: false,
        size: 3,
      },
      {
        name: "accommodationProvided",
        fieldId: "accommodationProvided",
        label: "Accommodation Provided",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
      {
        name: "transportProvided",
        fieldId: "transportProvided",
        label: "Transport Provided",
        type: "checkbox",
        value: true,
        style: {
          padding: "30px 10px 0",
          size: "small",
        },
        isRequired: false,
        size: 2,
      },
    ],
  },
];
